import React from 'react';
import { useParams, Link } from 'react-router-dom';
import './css/NewsDetail.css';
import newsData from '../components/NewsData';

const NewsDetail: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const newsItem = newsData[Number(id)];

    if (!newsItem) {
        return <div>News not found.</div>;
    }

    return (
        <div className="news-detail-container">
            <div className="news-detail-main">
                <h2>{newsItem.title}</h2>
                <img src={newsItem.image} alt={newsItem.title} />
                <div className="news-content"> {newsItem.content}</div>
            </div>
            <div className="news-detail-sidebar">
                <h3>Шинэ мэдээ</h3>
                <ul>
                    {newsData
                        .map((item, index) => ({ ...item, index }))
                        .filter((item) => item.index !== Number(id))
                        .reverse()
                        .slice(0, 5)
                        .map((item) => (
                            <li key={item.index}>
                                <Link to={`/news/${item.index}`}>
                                    <img src={item.image} alt={item.title} />
                                    <span>{item.title}</span>
                                </Link>
                            </li>
                        ))}
                </ul>
            </div>
        </div>
    );
};

export default NewsDetail;
